module.exports = __webpack_public_path__ + "static/img/scholarship3.8860702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/scholarship3.png
// module id = X+3j
// module chunks = 1